/**
 * Demo Supabase client — DEV-ONLY.
 *
 * Este modulo NUNCA deve ser importado diretamente por hooks/telas.
 * Em vez disso, use os helpers em `lib/supabase.ts` (switchToDemo,
 * getDemoClient, etc), que delegam aqui via require() dinamico dentro
 * de `if (__DEV__)` — garantindo que o bundle de PRODUCAO nao inclua
 * este arquivo (Metro/Expo dead code elimination quando __DEV__ === false).
 *
 * Banco demo: https://wpyogisjlzkxxqguuiuz.supabase.co (separado de PROD).
 * Conta demo: demo-personal@arafit.com.br (UUID c0ffee00-1111-0000-0000-000000000001).
 *
 * Em build de producao:
 *   - signIn rejeita explicitamente o email demo
 *   - switchToDemo/getDemoClient sao no-op (retornam prod client)
 *   - este arquivo nao deve aparecer no bundle servido (verificar com grep)
 */
import type { SupabaseClient } from '@supabase/supabase-js';

const DEMO_URL = 'https://wpyogisjlzkxxqguuiuz.supabase.co';
const DEMO_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndweW9naXNqbHpreHhxZ3V1aXV6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzgzNTkxNzAsImV4cCI6MjA5MzkzNTE3MH0.amD8XCNUFKEsAe03zxaQiUIsJEiERsL1JkRWNoo8gWQ';

let _demoClient: SupabaseClient | null = null;

/**
 * Cria (com cache) o cliente demo. Recebe `makeClient` como parametro pra
 * reutilizar a mesma factory do supabase.ts (storage adapter, auth options).
 *
 * @param makeClient factory exportada por `lib/supabase.ts`
 */
export function getDemoClient(
  makeClient: (url: string, key: string) => SupabaseClient
): SupabaseClient {
  if (!_demoClient) _demoClient = makeClient(DEMO_URL, DEMO_KEY);
  return _demoClient;
}
